module.exports = __webpack_public_path__ + "img/bulb-icon.bc948ebd.svg";